/**
 * 화면 표기 — 금액은 여기서만 만든다 (2026-10-23).
 *
 * **왜 모았나**: 같은 금액이 화면마다 `₩1,234` · `1,234원` 으로 달리 보였고
 * `won()` 이 여섯 곳에 따로 있었다(아카이브 · 수주 판정 2곳 · 제안서 · 견적 · 정산).
 * 한 곳을 고쳐도 나머지가 그대로라 표기가 계속 벌어졌다.
 *
 * 쓰는 법:
 * - `won` — 금액을 글로 보일 때. `₩` 를 붙이고 모르는 값은 `—`
 * - `amount` — 열 머리에 「(원)」 처럼 단위를 적어 둔 표 셀. 숫자만
 *
 * 범위: 공고 · 수집·알림(영업)은 관리자 범위라 그대로 둔다.
 * 재무계획 PPE 표는 admin 과 맞춘 **만원** 단위라 여기를 쓰지 않는다(`formatCurrency`).
 */

/** `₩1,234` · 모르면 `—`. 0 은 `₩0` 으로 보인다 — 「모른다」와 「0 원」은 다르다 */
export const won = (v: number | null | undefined): string =>
  v == null ? '—' : `₩${Math.round(v).toLocaleString('ko-KR')}`;

/** 단위를 열 머리에 적어 둔 표 셀 — 숫자만 */
export const amount = (v: number | null | undefined): string =>
  v == null ? '—' : Math.round(v).toLocaleString('ko-KR');
